import { useSearchParams } from 'react-router-dom';

type SetSearchParamsArg = Parameters<ReturnType<typeof useSearchParams>[1]>[0];
type SetSearchParamsUpdater = (prev: URLSearchParams) => URLSearchParams;

const resolveSearchParams = (nextInit: SetSearchParamsArg, prev: URLSearchParams): URLSearchParams => {
  if (typeof nextInit === 'function') return new URLSearchParams((nextInit as SetSearchParamsUpdater)(prev));
  return new URLSearchParams(nextInit as URLSearchParams);
};

export default function useSearchParamsPreserving(preservedKeys: string[]) {
  const [searchParams, setSearchParams] = useSearchParams();

  const wrappedSetSearchParams: typeof setSearchParams = (nextInit, navigateOpts) => {
    setSearchParams((prev) => {
      const next = resolveSearchParams(nextInit, prev);
      preservedKeys.forEach((key) => {
        const value = prev.get(key);
        if (value) next.set(key, value);
      });
      return next;
    }, navigateOpts);
  };

  return [searchParams, wrappedSetSearchParams] as ReturnType<typeof useSearchParams>;
}
